<mat-toolbar class="header-container" *transloco="let translate">
    <mat-toolbar-row class="tool-bar matHeader pl-0">
        <span class="navLogo max-w-[234px] min-w-[100px] mr-2">
            <a *ngIf="!isInGuestMode" [routerLink]="'/organizations/' + currentOrganizationId + '/category'">
                <ng-container *ngIf="!imgSrc">
                    <img class="headerLogo px-[25px]" [src]="'/assets/images/' + logoHref + 'header-logo.png'" alt="enComply" />
                </ng-container>
                <ng-container *ngIf="imgSrc?.length > 0">
                    <img class="headerLogo px-[25px] max-h-[40px]" [src]="'data:image/jpeg;base64,' + imgSrc" alt="Organization" />
                </ng-container>
            </a>
            <a *ngIf="isInGuestMode">
                <img class="headerLogo px-[25px]" [src]="'/assets/images/' + logoHref + 'header-logo.png'" alt="enComply" />
            </a>
        </span>
        <ul>
            <li>
                <span
                    class="text-font-style"
                    [textContent]="currentOrganization ? currentOrganization.displayTenantName : translate('Select Tenant')"></span>
                <material-button
                    class=""
                    [classList]="['!bg-transparent', '!text-[#00a651]', '!text-[14px]', '!w-auto', '!tracking-normal', '!font-normal']"
                    [hideRipple]="true"
                    [buttonType]="'flat'"
                    (buttonClicked)="showOrganizations()"
                    [text]="translate('Change')"></material-button>
            </li>
            <li
                *ngIf="
                    (_commonUtils.analyticsServiceTypes?.split(',').includes('DASHBOARD') ||
                        _commonUtils.analyticsServiceTypes?.split(',').includes('WIDGET')) &&
                    canShowAnalytics
                ">
                <material-menu-button
                    [menuClassList]="'!max-w-[350px] !w-[100vw] !max-h-[80vh] border-t-2 border-[#00a651]'"
                    [showArrows]="insights.length > 0 ? true : false"
                    [hideRipple]="true"
                    [buttonType]="'icon'"
                    [prefixIconType]="'image'"
                    (buttonClicked)="getDashboardCharts()"
                    (menuClosedAction)="filterDashboardName = ''"
                    [text]="translate('Dashboard')"
                    [prefixImgSrc]="'assets/images/new-ui/dashboard.png'"
                    [prefixImgAlt]="'dashboard-icon'">
                    <mat-progress-bar *ngIf="isDashboardsLoading" mode="indeterminate"></mat-progress-bar>
                    <ng-container *transloco="let translate">
                        <mat-form-field class="px-3 pt-3" *ngIf="!isDashboardsLoading">
                            <input
                                matInput
                                [placeholder]="translate('Search')"
                                type="text"
                                [(ngModel)]="filterDashboardName"
                                (click)="$event.stopPropagation()"
                                (keydown)="$event.stopPropagation()" />
                            <mat-icon
                                matSuffix
                                class="-mb-2 cursor-pointer"
                                *ngIf="filterDashboardName"
                                (click)="$event.stopPropagation(); filterDashboardName = ''">
                                close
                            </mat-icon>
                            <mat-icon matSuffix class="-mb-2 cursor-pointer" *ngIf="!filterDashboardName">search</mat-icon>
                        </mat-form-field>
                    </ng-container>
                    <div class="tenantsMenuContainer !bg-white" *ngIf="!isDashboardsLoading">
                        <div class="insightsContainer">
                            <ng-container
                                *ngIf="
                                    insights | FilterPipe : 'displayName' : filterDashboardName : null : 'serviceName' as filteredInsights
                                ">
                                <ng-container *ngIf="filteredInsights.length > 0; else noInsights">
                                    <a
                                        *ngFor="let insight of filteredInsights"
                                        class="mat-menu-item appName appReportContainer !hover:bg-[#0000008a]"
                                        mat-menu-item
                                        (click)="openInsights()"
                                        [routerLink]="'organizations/' + currentOrganization?.id + '/dashboard'"
                                        [queryParams]="{ insight: insight.serviceName }"
                                        routerLinkActive="activeOrganization">
                                        <div [title]="insight.displayName || insight.serviceName" class="appDisplayName">
                                            <span [textContent]="insight.displayName || insight.serviceName"></span>
                                        </div>
                                    </a>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </material-menu-button>
            </li>
            <li *ngIf="canShowTaskManagement">
                <span
                    class="text-[14px] cursor-pointer"
                    [routerLink]="'/organizations/' + currentOrganizationId + '/tasks'"
                    [routerLinkActive]="'!text-taxillaGreen'"
                    [textContent]="translate('Tasks')"></span>
            </li>
        </ul>
        <span class="spacer px-5">
            <div class="cssmarquee !bg-transparent" *ngIf="showMarquee && marqueeText">
                <h1 class="!leading-[45px]" [textContent]="marqueeText"></h1>
            </div>
        </span>
        <ul class="items-center">
            <li *ngIf="!isInGuestMode" class="relative">
                <app-settings-nested-menu
                    [menu]="settings"
                    [main]="true"
                    [isSettingsSelected]="isSettingsSelected"
                    [isNewUI]="true"></app-settings-nested-menu>
            </li>
            <li *ngIf="!isInGuestMode && !hideSwitchUISKin" class="relative">
                <div class="relative mx-[5px]">
                    <span
                        (click)="switchToNewUI()"
                        class="cursor-pointer border-none hover:text-taxillaGreen focus:text-taxillaGreen px-2 text-xs font-bold text-center no-underline"
                        [textContent]="onNewUI ? translate('Switch to Old UI') : translate('Switch to New UI')"></span>
                </div>
            </li>
            <li *ngIf="!isInGuestMode" class="relative">
                <app-user-details [isNewUI]="true"></app-user-details>
            </li>
        </ul>
    </mat-toolbar-row>
</mat-toolbar>

<ng-template #noInsights>
    <div class="text-center p-3" *transloco="let translate">
        <div class="text-muted" [textContent]="translate('No records found')"></div>
    </div>
</ng-template>
